import classnames from 'classnames';
import Link from 'next/link';
import Img from '../../components/Img';
import styles from './AuthorCard.module.scss';

type AuthorCardProps = {
  url?: string,
  avatar?: string,
  avatarSize?: number,
  name: string,
  info: string | string[],
  className?: string,
  verticalLayout?: boolean,
};
const AuthorCard = ({
  className, avatar, avatarSize, name, info, verticalLayout, url,
}: AuthorCardProps) => (
  <div className={classnames(styles.author, className, {
    [styles.vertical]: verticalLayout,
  })}
  >
    {url ? (
      <Link
        href={url}
        className={styles.author__avatar}
        style={avatarSize ? { width: avatarSize, height: avatarSize } : {}}
      >
        <Img
          src={avatar || '/'}
          alt={name}
          withPreloader
        />
      </Link>
    ) : (
      <div
        className={styles.author__avatar}
        style={avatarSize ? { width: avatarSize, height: avatarSize } : {}}
      >
        <Img
          src={avatar || '/'}
          alt={name}
          withPreloader
        />
      </div>
    )}

    <div className={styles.author__content}>
      {url ? (
        <Link
          href={url}
          className={styles.author__name}
        >
          {name}
        </Link>
      ) : (
        <p
          className={styles.author__name}
        >
          {name}
        </p>
      )}

      <p className={styles.author__info}>
        {Array.isArray(info) ? info.map(item => <span key={item}>{item}</span>) : info}
      </p>
    </div>
  </div>
);

export default AuthorCard;
